import { Component, Input, OnInit } from '@angular/core';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { Store } from '@ngrx/store';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConstsHelper } from '../../../../../helpers/consts.helper';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../../../../environments/environment';
import moment from 'moment';
import { FileService } from '../../../services/file.service';
import { CommunicationDetailPaginatorInterface } from '../../../models/communication-detail-paginator.interface';
import { DownloadFile } from '../../../../bills/store/actions/bills.actions';
import { SaveCustomerMission } from '../../../store/actions/customer-mission.actions';

@Component({
  selector: 'app-communication-detail',
  templateUrl: './communication-detail.component.html',
  styleUrls: ['./communication-detail.component.css'],
  standalone: false
})
export class CommunicationDetailComponent implements OnInit {

  @Input()
  procedureCode: string;

  files: CommunicationDetailPaginatorInterface|null;
  brand = environment.data.brand;
  errors: any = {
    startDate: {
      required: `Ce champ est obligatoire.`,
      pattern: 'Veuillez saisir une date au bon format JJ/MM/AAAA.'
    },
    endDate: {
      required: `Ce champ est obligatoire.`,
      pattern: 'Veuillez saisir une date au bon format JJ/MM/AAAA.'
    }
  };
  reportsForm: FormGroup;
  reportsFormSubmitted: boolean;
  errorDate: string|null;
  constructor(
      private store: Store<any>,
      private fileService: FileService,
      private formBuilder: FormBuilder,
      private domSanitizer: DomSanitizer,
      private matIconRegistry: MatIconRegistry,
  ) {}

  ngOnInit() {
    this.files = null;
    this.reportsFormSubmitted = false;
    this.errorDate = null;
    this.matIconRegistry.addSvgIcon(
        'agenda',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
            '../../../../../../../assets/images/icons/' + this.brand + '_small-agenda.svg'
        )
    );
    this.initForm();
    this.fileService.getCommunicationDetailFiles(1, 10).subscribe(
        response => {
          this.files = response;
        }
    );
  }

  initForm() {
    this.reportsForm = this.formBuilder.group({});
    this.reportsForm.addControl(
        'startDate',
        this.formBuilder.control(
            '',
            [Validators.required, Validators.pattern(ConstsHelper.frenchDatePattern)]
        )
    );
    this.reportsForm.addControl(
        'endDate',
        this.formBuilder.control(
            '',
            [Validators.required, Validators.pattern(ConstsHelper.frenchDatePattern)]
        )
    );
  }

  handleDate(value: string, field: string) {
    this.reportsForm.get(field).setValue(value);
  }

  save() {
    this.reportsFormSubmitted = true;
    this.errorDate = null;
    if (
        this.reportsForm.valid &&
        moment(this.reportsForm.get('startDate').value, 'DD/MM/YYYY') < moment(this.reportsForm.get('endDate').value, 'DD/MM/YYYY')
    ) {
      this.store.dispatch(
          new SaveCustomerMission(
              {
                startDate: moment(this.reportsForm.get('startDate').value, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                endDate: moment(this.reportsForm.get('endDate').value, 'DD/MM/YYYY').format('YYYY-MM-DD'),
              },
              this.procedureCode,
              'bill'
          )
      );
    } else {
      this.errorDate = 'La date de fin doit être supérieur à la date de début.';
    }
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  download(fileId: number, fileName: string) {
    this.store.dispatch(new DownloadFile(fileId, 'communication_detail', fileName, 'application/octet-stream'));
  }

  getError(formControlName: string): string {
    let errorMsg = '';
    if (this.reportsForm.controls[formControlName].invalid) {
      Object.keys(this.reportsForm.controls[formControlName].errors).map(
          key => {
            errorMsg = this.errors[formControlName][key];
          }
      );
    }
    return errorMsg;
  }
}
